import { useState, useRef, useEffect } from 'react';
import * as echarts from 'echarts';
import { proportion } from "@/apis/statistics"

const ResourceProport = () => {
	const chartRef = useRef(null);
	const [dataArr, setDataArr] = useState([
		{
			name: "地理空间数据",
			value: 0,
		},
		{
			name: "人工智能训练集",
			value: 0,
		},
		{
			name: "网络数据服务",
			value: 0,
		},
		{
			name: "开源代码",
			value: 0
		}, {
			name: "网络处理服务",
			value: 0
		}, {
			name: "容器镜像",
			value: 0
		}, {
			name: "可执行文件",
			value: 0
		}, {
			name: "开放SDKs",
			value: 0
		},
		{
			name: "开放规范",
			value: 0
		}, {
			name: "技术文档",
			value: 0
		}, {
			name: "开发指南",
			value: 0
		}, {
			name: "培训及课程材料",
			value: 0
		},
		{
			name: "web应用工程",
			value: 0
		}
	]);

	const getList = () => {
		proportion().then(res => {
			const result = res?.data || {}
			setDataArr([
				{
					name: "地理空间数据",
					value: result.OpenGeospatialData || 0,
				},
				{
					name: "人工智能训练集",
					value: result.OpenAITrainingData || 0,
				},
				{
					name: "网络数据服务",
					value: result.OpenDataServices || 0,
				},
				{
					name: "开源代码",
					value: result.OpenCodes || 0
				}, {
					name: "网络处理服务",
					value: result.OpenProcessServices || 0
				}, {
					name: "容器镜像",
					value: result.OpenContainerImages || 0
				}, {
					name: "可执行文件",
					value: result.OpenExecutables || 0
				}, {
					name: "开放SDKs",
					value: result.OpenSDKs || 0
				},
				{
					name: "开放规范",
					value: result.OpenSpecifications || 0
				}, {
					name: "技术文档",
					value: result.TechnicalDocs || 0
				}, {
					name: "开发指南",
					value: result.DevelopmentGuidelines || 0
				}, {
					name: "培训及课程材料",
					value: result.TrainingCourseMaterials || 0
				},
				{
					name: "web应用工程",
					value: result.OpenWebApps || 0
				}
			])
		});
	}
	useEffect(() => {
		getList()
	}, [])

	useEffect(() => {
		const chartDom = chartRef.current;
		const myChart = echarts.init(chartDom);
		const total = dataArr.map(item => item.value).reduce((a, b) => a + b)
		const option = {
			legend: {
				orient: 'vertical',
				right: '0',
				icon: 'square',
				itemWidth: 10,
				itemHeight: 10,
				top: '10px',
				formatter: function (name) {
					// 添加
					let target = 0
					// let precent = 0
					for (let i = 0; i < dataArr.length; i++) {
						if (dataArr[i].name === name) {
							target = dataArr[i].value
							// precent = ((dataArr[i].value / total) * 100).toFixed(1)
						}
					}

					var arr = [
						'{a|' + name + '}',
						'{b|' + target + '}',
						'{c|条}',
						// '{b|' + precent + '}',
						// '{c|%}'
					]
					return arr.join('  ')
				},
				textStyle: {
					// 添加
					rich: {
						a: {
							fontSize: 12,
							color: 'rgba(0,0,0,0.7)',
							width: 90
						},
						b: {
							fontSize: 14,
							color: '#000',
							fontFamily: 'DIN-Regular'
						},
						c: {
							fontSize: 10,
							color: 'rgba(0,0,0,0.7)',
							width: 16
						}
					}
				}
			},

			series: [
				{
					name: '',
					type: 'pie',
					radius: ['20%', '45%'],
					center: ['22%', '49%'],
					label: {
						show: false,
						position: 'center',
						formatter: param => {
							const val = ((param.value / total) * 100).toFixed(1)
							const arr = ['{b|' + param.name + '\n}', `{a|${val}}`, `{b|% }`]
							return arr.join(' ')
						},
						color: '#d62293',
						rich: {
							a: {
								fontSize: 16,
								fontFamily: 'DIN-Regular'
							},
							b: {
								fontSize: 14
							}
						}
					},
					emphasis: {
						label: {
							show: true,
							fontSize: 40,
							fontWeight: 'bold'
						}
					},
					labelLine: {
						show: false
					},
					data: dataArr,
					itemStyle: {
						normal: {
							color: function (params) {
								var colorList = [
									['rgba(255, 221, 225,0.1)', '#ffdde1 '],
									['rgba(255, 175, 189,0.1)', '#ffafbd'],
									['rgba(255, 113, 154,0.1)', '#FF719A'],

									['rgba(183, 221, 183,0.1)', '#b7ddb7'],
									['rgba(179, 255, 171,0.1)', '#b3ffab'],
									['rgba(155, 225, 93,0.1)', '#9be15d'],
									['rgba(101, 189, 96,0.1)', '#65bd60'],
									['rgba(79, 181, 118,0.1)', '#4fb576'],

									['rgba(248, 246, 185,0.2)', '#f8f6b9'],
									['rgba(236, 231, 111,0.2)', '#ece76f'],
									['rgba(223, 217, 66,0.1)', '#dfd942'],
									['rgba(255, 255, 0,0.1)', '#ffff00'],

									['rgba(79, 172, 254,0.1)', '#4facfe'],
								]
								var index = params.dataIndex
								return new echarts.graphic.LinearGradient(0, 0, 1, 1, [
									{
										offset: 0,
										color: colorList[index][0]
									},
									{
										offset: 1,
										color: colorList[index][1]
									}
								])
							}
						}
					}
				}
			]
		};
		myChart.setOption(option);
		window.addEventListener('resize', () => {
			myChart && myChart.resize();
		});
		return () => {
			myChart.dispose();
		};
	}, [dataArr]);
	return <div ref={chartRef}>曲线图</div>
}
export default ResourceProport;